import { render, staticRenderFns } from "./activity-form-versions.vue?vue&type=template&id=2f2eed54&scoped=true&"
import script from "./activity-form-versions.vue?vue&type=script&lang=js&"
export * from "./activity-form-versions.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-versions.vue?vue&type=style&index=0&id=2f2eed54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2eed54",
  null
  
)

component.options.__file = "activity-form-versions.vue"
export default component.exports